import React, { Component } from "react";
import { FiCast, FiLayers, FiUsers, FiMonitor } from "react-icons/fi";
import fish from "../../assets/images/icon/fish.svg";
import auth from "../../assets/images/icon/auth.svg";
import shield from "../../assets/images/icon/shield.svg";
import font from "../../assets/images/icon/font.png";
import heart from "../../assets/images/icon/heart.png";
import ocr from "../../assets/images/icon/ocr.svg";
import watch from "../../assets/images/icon/watch.svg";

const ServiceList = [
  {
    icon: fish,
    title: "어종검출 API",
    description:
      "이미지 입력시 AI모델이 물거기를 탑지하여 물고기의 종류,학명,서식지등의 정보를 제공합니다.",
    link: "/service-details#fishDetection",
  },
  {
    icon: ocr,
    title: "광학문자인식(OCR) API",
    description:
      "OCR 기술을 활용하여 이미지 내 텍스트를 텍스트 데이터로 변환해줍니다.",
    link: "/service-details#Ocr",
  },
  {
    icon: font,
    title: "서체(Font)인식 API",
    description:
      "이미지내 텍스트의 서체(Font)를 인식하여 해당 서체 정보를 제공합니다.",
    link: "/service-details#font",
  },
  {
    icon: auth,
    title: "국민건강보험공단 API",
    description:
      "국민건강보험공단에서 제공하는 검진현황, 건강예측 정보를 제공합니다.",
    //   "국민건강보험공단 로그인시 네이버 및 카카오 간편인증을 제공합니다.",
    link: "/service-details#health-1",
  },
  // {
  //   icon: shield,
  //   title: "국민건강보험공단 공동인증서 인증",
  //   description:
  //     "국민건공보험공단 공동인증서로그인시 공동인증서 인증서비스를 제공합니다.",
  //   link: "/service-details#health-2",
  // },
  // {
  //   icon: shield,
  //   title: "국민건강보험공단 공동인증서 등록",
  //   description:
  //     "국민건강보험공단 공동인증서 로그인시 필요한 공동인증서 등록 서비스를 제공합니다.",
  //   link: "/service-details#health-3",
  // },
  // {
  //   icon: heart,
  //   title: "국민건강보험공단 질환예측",
  //   description:
  //     "국민 건강보험공단에서 제공하는 질환에대한 예측하는 서비스를 제공합니다.",
  //   link: "/service-details#health-4",
  // },
  // {
  //   icon: watch,
  //   title: "국민건강보험공단 건강검진 내역",
  //   description: "건강보험공단에서 실시한 건강검진 내역을 제공합니다.",
  //   link: "/service-details#health-5",
  // },
];

class ServiceThree extends Component {
  render() {
    const { column } = this.props;
    const ServiceContent = ServiceList.slice(0, this.props.item);

    return (
      <React.Fragment>
        <div className="row">
          {ServiceContent.map((val, i) => (
            <div className={`${column}`} key={i}>
              <a href={val.link}>
                <div className="service service__style--2">
                  <div className="icon">
                    <img
                      className="icon-w-p40"
                      src={val.icon}
                      alt=""
                      srcset=""
                    />
                  </div>
                  <div className="content">
                    <h3 className="title">{val.title}</h3>
                    <p>{val.description}</p>
                  </div>
                </div>
              </a>
            </div>
          ))}
        </div>
      </React.Fragment>
    );
  }
}
export default ServiceThree;
